import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from '../../lib/api.js';
import { useAgentStore } from '../../store/agentStore.jsx';

const EXPORT_TYPES = [
  { value: 'devices', label: 'Device Inventory (CSV)' },
  { value: 'alerts', label: 'Alert History (CSV)' },
  { value: 'topology', label: 'Topology Snapshot (JSON)' },
];

export default function ExportButton() {
  const { agentId } = useAgentStore();
  const [open, setOpen] = useState(false);

  const exportMutation = useMutation({
    mutationFn: (type) => api.post('/reports/export', { type, agent_id: agentId }),
    onSuccess: (data) => {
      setOpen(false);
      alert(`Report exported: ${data.data.key} (${data.data.size} bytes)`);
    },
  });

  if (!agentId) return null;

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-600 hover:bg-gray-50"
      >
        Export
      </button>
      {open && (
        <div className="absolute right-0 top-full z-10 mt-1 w-56 rounded-lg border border-gray-200 bg-white shadow-lg">
          {EXPORT_TYPES.map((type) => (
            <button
              key={type.value}
              onClick={() => exportMutation.mutate(type.value)}
              disabled={exportMutation.isPending}
              className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            >
              {type.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
